import { useToastContext } from 'context/ToastContext';
import useLocale from 'hooks/useLocale';
import useLocalizedData from 'hooks/useLocalizedData';
import { useEffect, useState } from 'react';
import { fetchFooter } from 'services/Strapi.service';
import { extractErrorMessage } from 'utils/axiosUtils';
import FOOTER_LABELS from './Footer.labels';

const useFooter = () => {
  const locale = useLocale();
  const { showToast } = useToastContext();
  const [data, setData] = useState(null);
  const [openFooterTab, setOpenFooterTab] = useState({});
  const [labels] = useLocalizedData(FOOTER_LABELS);

  useEffect(() => {
    fetchFooter(locale)
      .then(({ data }) =>
        setData(typeof data == 'object' && Array.isArray(data?.data) ? (data.data.at(0)?.attributes ?? null) : null)
      )
      .catch((err) => {
        showToast({ title: 'Footer UI', message: extractErrorMessage(err) });
        setData(null);
      })
      .finally(() => {
        setOpenFooterTab({});
      });
  }, [locale]);

  return {
    labels: labels,
    data: data,
    openFooterTab: openFooterTab,
    toggleFooterTab: (id) => setOpenFooterTab((v) => ({ ...v, [id]: !v[id] })),
  };
};
export default useFooter;
